import { slugify } from 'helpers/slugfy'
import { FC } from 'react'
import type { FourInlineCardsProps } from '.'
import s from './four-inline-cards.module.css'

const FourInlineCards: FC<FourInlineCardsProps> = ({ cards }) => {
  return (
    <div className={s.root}>
      <div className={s.container}>
        <div className={s.cards}>
          {cards.map(({ icon, title, description }) => (
            <div className={s.card} key={`four-inline-cards-${slugify(title)}`}>
              {icon && <div className={s.icon}>{icon}</div>}
              <div>
                <div className={s.title}>{title}</div>
                {description && <div className={s.description}>{description}</div>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FourInlineCards
